var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAppInstallation = function SvgAppInstallation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#app-installation_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5 1H1.667A.667.667 0 0 0 1 1.667V5c0 .368.298.667.667.667H5A.667.667 0 0 0 5.667 5V1.667A.667.667 0 0 0 5 1M12.333 1H9a.667.667 0 0 0-.667.667V5c0 .368.299.667.667.667h3.333A.667.667 0 0 0 13 5V1.667A.667.667 0 0 0 12.333 1M8.333 12.333V9c0-.368.299-.667.667-.667h1.667M5 8.333H1.667A.667.667 0 0 0 1 9v3.333c0 .368.298.667.667.667H5a.667.667 0 0 0 .667-.667V9A.667.667 0 0 0 5 8.333"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#app-installation_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    d: "M13.667 11a.665.665 0 0 0-.667-.667M13 13a2 2 0 1 0-1.982-1.731c.02.145.03.217.023.263a.3.3 0 0 1-.04.115c-.022.04-.062.08-.141.16l-1.704 1.704c-.057.057-.086.086-.107.12a.3.3 0 0 0-.04.096c-.009.038-.009.08-.009.16v.58c0 .186 0 .28.036.351a.33.33 0 0 0 .146.146c.071.036.165.036.351.036h.8v-.667H11v-.666h.667l.526-.527c.08-.08.12-.119.16-.142a.3.3 0 0 1 .115-.039c.046-.006.118.004.263.023Q12.863 13 13 13"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "app-installation_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "app-installation_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 8h8v8H8z"
  })))));
};
export default SvgAppInstallation;